import { render, staticRenderFns } from "./medal_send.vue?vue&type=template&id=1f36e7b4&scoped=true"
import script from "./medal_send.vue?vue&type=script&lang=ts"
export * from "./medal_send.vue?vue&type=script&lang=ts"
import style0 from "./medal_send.vue?vue&type=style&index=0&id=1f36e7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36e7b4",
  null
  
)

export default component.exports